import loadable from '@loadable/component';
import {loadableAuthParams} from '@components/Skeleton/loadableParams';

const Auth = {
  SignIn: loadable(async () => import('./SignIn'), loadableAuthParams),
};

export default Auth;
